
import TableList from "@components/templates/tablelist";
import compAddMember from './addmember.vue';
import { mapGetters } from "vuex";
import { HttpGetStaffList, HttpBatchDeleteStaff } from '@/service/department/departmentmanage.js'

export default {
    mixins: [TableList],
    props: ['cuttentDepartment','companyList1'],
    components: {
        compAddMember,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                },
                deptId:'',
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            orgId: '',
        };
    },
    watch: {
        "companyList1": {
            immediate: true,
            handler (val) {
                this.companyList = val
            },
        },
        "cuttentDepartment": {
            immediate: true,
            handler (val) {
                this.formData.deptId = val;
                this.orgId = this.companyList.filter(item=>item.id == this.cuttentDepartment)[0]?this.companyList.filter(item=>item.id == this.cuttentDepartment)[0].scope : '';
                this.updateList({deptId:val})
            }
        },
	},
    methods: {
        ajaxRequest: HttpGetStaffList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case "add":
                    this.operate = {
                        show: true,
                        title: "添加成员",
                        component: "compAddMember",
                        selectDeptId:this.cuttentDepartment,
                        companyList: this.companyList1,
                        type: 'add',
                        width: 460,
                        showFooter: false,
                        on:{
                            "on-success":()=>{
                                this.updateList({deptId:this.formData.deptId})
                            }
                        }
                    }
                    break;
                case "edit":
                    this.operate = {
                        show: true,
                        title: "编辑成员",
                        component: "compAddMember",
                        selectDeptId:this.cuttentDepartment,
                        companyList: this.companyList1,
                        params: params,
                        type: 'edit',
                        width: 460,
                        showFooter: false,
                        on:{
                            "on-success":()=>{
                                this.updateList({deptId:this.formData.deptId})
                            }
                        }
                    }
                    break;
                case "batchImport":
                    this.operate = {
                        show: true,
                        title: '批量导入',
                        width: 460,
                        showFooter: false,
                        // actionurl: process.env.VUE_APP_APIURL_UC + "/api/v2/Inbound/importOrder",
                        // name: "multipartFile",
                        // component: "compUpload",
                        // downrul: process.env.VUE_APP_APIURL_UC + '/api/v1/UcDepartmentEmployee/downloadTemplate',
                        // params: {orgId: this.companyList.filter(item=>item.id == this.cuttentDepartment)[0].scope},
                        // localurl:true,
                        component: "compUpload",
                        name: "multipartFile",
                        data:{type:1},
                        action: process.env.VUE_APP_APIURL_UC + "/api/v1/UcDepartmentEmployee/import",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_UC + '/api/v1/UcDepartmentEmployee/downloadTemplate', {orgId: this.orgId}, 'download')
                        },
                        on:{
                            "on-success":()=>{
                                this.updateList({deptId:this.formData.deptId})
                            }
                        },
                        callback: ()=>{
                            this.checkedData=[]
                        },
                    };
                    break;
                case "batchExport":
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_UC + "/api/v1/UcDepartmentEmployee/batchExport", {deptId: this.cuttentDepartment},
                        {
                            executor: "request",
                            download: true,
                            method: 'get'
                        }
                    );
                    break;
                case "batchDelete":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: "批量删除",
                        params:{ ids: this.checkedData.join(',')},
                        desc: "一旦删除，数据不可恢复，请谨慎操作",
                        ajaxRequest:HttpBatchDeleteStaff,
                        callback: ()=>{
                            this.checkedData=[]
                        },
                    };
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusWareList']),
        columns() {
            return [{
				type: 'selection',
				formName: 'id',
				width: 60
			},
            {
                title: '姓名',
                key: "name",
                render:(h,{row})=>{
                    return <div>
                            <span onClick={this.handleOperates.bind(this, row.id, 'edit')} style="cursor:pointer">{row.name}</span>
                            <span style="margin-left:10px;color:black;background:#48f548">{row.manageType == 1? '主管' :''}</span>
                        </div>
                }
            },
            {
                title: '邮箱',
                key: 'email',
            },
            {
                title: '电话',
                key: 'phone',
            },
            {
                title: '工号',
                key: 'workno',
            },
            {
                title: '备注',
                key: 'remark'
            }
            ];
        },
        ToolsData() {
            return [
                {
                    name: "添加成员",
                    operate: "add",
                    theme: "primary",
                    show: true
                },
                {
                    name: "批量导入",
                    operate: 'batchImport',
                    show: true
                },
                {
                    name: "批量导出",
                    operate: 'batchExport',
                    show: true,
                },
                {
                    name: '批量删除',
                    operate: 'batchDelete',
                    show: true,
                    batch: true,
                }
            ]
        },
    },
};
